import {isFeatureEnabled} from '@github-ui/feature-flags'

export function isOneCopilotBrowserTelemetryPathExcluded(pathname: string): boolean {
  return /^\/copilot\/agents(?:\/|$)/.test(pathname) || /^\/copilot\/(?:chats|c)\/[^/]+\/?$/.test(pathname)
}

export function isOneCopilotBrowserTelemetryEnabled(): boolean {
  try {
    if (typeof window !== 'undefined' && isOneCopilotBrowserTelemetryPathExcluded(window.location.pathname))
      return false
    return isFeatureEnabled('one_copilot_chat')
  } catch {
    return false
  }
}
